export default __webpack_public_path__ + "218e43fe6d5a1e8e80d3f7420a4152db.png";